import React from 'react';
import Menu from './Menu'
import Sds from './sds/Sds'
import SdsResult from './sds/result'
import Sas from './sas/sas'
import { HashRouter, Route, Switch } from 'react-router-dom'
function App() {
  return (
    <div className="App">
      <HashRouter>
        <Switch>
          <Route path="/" exact component={Menu} />
          <Route path="/Sds" exact component={Sds} />
          <Route path="/Sds/Result" component={SdsResult} />
          <Route path="/sas" component={Sas} />
        </Switch>
      </HashRouter>

    </div>
  );
}

export default App;
